const IMAGE_MAP = {
  "portrait-keyur.jpg": "/images/portrait-keyur.jpg",
  "gd-students5.jpg": "/images/gd-students5.jpg",
  "wm-test3.jpg": "/images/wm-test3.webp",
  "pragati-still.jpg": "/images/pragati-still.webp",
  "pragati-vr1.jpg": "/images/pragati-still.webp",
  "evam-minister.jpg": "/images/evam-minister.webp",
  "swasthyaa-launch2.jpg": "/images/swasthyaa-launch2.jpg",
  "chetna-system.jpg": "/images/chetna-system.jpg",
  "voter1.jpg": "/images/voter1.webp",
  "gd-workshop-teachers1.jpg": "/images/gd-workshop-teachers1.webp",
  "gd-champ-moderating.jpg": "/images/gd-champ-moderating.webp",
  "evam-launch.jpg": "/images/evam-launch.webp",
  "evam-field1.jpg": "/images/evam-field1.webp",
  "wm-inspect1.jpg": "/images/wm-inspect1.jpg",
  "wm-shopkeeper.jpg": "/images/wm-shopkeeper.webp",
  "pragati-training.jpg": "/images/pragati-training.jpg",
  "swasthyaa-officers.jpg": "/images/swasthyaa-officers.webp",
  "swasthyaa-training3.jpg": "/images/swasthyaa-training3.jpg",
  "chetna-mothers1.jpg": "/images/chetna-mothers1.webp",
  "voter2.jpg": "/images/voter2.webp",
  "voter3.jpg": "/images/voter3.jpg",
};

export const ImagePlaceholder = ({ file, ratio = "16 / 10", label, className = "" }) => {
  const src = IMAGE_MAP[file];
  if (src) {
    return (
      <img
        src={src}
        alt={label || file}
        loading="lazy"
        data-testid={`image-${file}`}
        className={`w-full object-cover block ${className}`}
        style={{ aspectRatio: ratio, background: "var(--navy-100)" }}
      />
    );
  }
  return (
    <div
      role="img"
      aria-label={label || `Placeholder for ${file}`}
      data-testid={`placeholder-${file}`}
      className={`flex items-center justify-center ${className}`}
      style={{
        aspectRatio: ratio,
        background: "var(--navy-100)",
        border: "1px dashed var(--border-default)",
      }}
    >
      <span className="caption px-2 text-center" style={{ color: "var(--ink-500)" }}>
        {file}
      </span>
    </div>
  );
};
